class CommandManager {
    constructor(env) {
        //环境
        this.env = env;
        //命令组
        this.commands = [];
        //重做组
        this.redoCommands = [];
    }
    async execute(command) {
        const result = await command.do();
        this.commands.push(command);
        this.redoCommands = [];
        this.log(command);
        return result;
    }

    async revoke() {
        const command = this.commands.pop();
        await command.prev();
        this.redoCommands.push(command);
        this.log(command);
    }

    async redo() {
        const command = this.redoCommands.pop();
        await command.do();
        this.commands.push(command);
        this.log(command);
    }

    log(command) {
        if (command.containChange) {
            if (this.env.listener['contain-change']) {
                this.env.listener['contain-change'](command);
            }

        }
        if (this.env.listener['step']) {
            this.env.listener['step']({
                revoke: this.commands.length,
                redo: this.redoCommands.length,
            });
        }
    }

}

export default CommandManager;
